// ----------------------------------------------------------------------

const MuiAppBar = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    color: 'transparent',
  },
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: { boxShadow: 'none' },
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const appBar = {
  MuiAppBar,
};
